import { ReactElement, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import createStyles from '@guestyci/foundation/createStyles';

const useGlobalStyles = createStyles({
  '@global': {
    body: {
      height: '100%',
      backgroundColor: '#ffffff',
    },
    html: {
      height: '100%',
    },
    '#root': {
      height: '100%',
    },
  },
});

interface IDeviceDetectionContainerProps {
  desktop: ReactElement;
  mobile: ReactElement;
}

function DeviceDetectionContainer({
  desktop,
  mobile,
}: IDeviceDetectionContainerProps) {
  useGlobalStyles();
  const location = useLocation();
  const isAllowedMobile = useRef(location.search.includes('allowMobile=true'));

  // A query string parameter 'isMobile' indicates that the user is viewing
  // the page from within the mobile app (in a WebView).
  if (location.search.indexOf('isMobile') !== -1) {
    window.localStorage.setItem('isMobile', '1');
    // Dio uses navigator.gfhPlatform to differentiate between mobile and web.
    if (navigator) {
      // @ts-ignore
      navigator.gfhPlatform = 'mobile';
    }
  }
  const isWebView = window.localStorage.getItem('isMobile') === '1';

  if (isAllowedMobile.current) {
    return desktop;
  }
  // Detect the user's device. On desktop, we show the app as normal. On mobile
  // (if not in a WebView), we show the prompt to download the mobile app.
  return <>{isMobile && !isWebView ? mobile : desktop}</>;
}
export default DeviceDetectionContainer;
